import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import {
  provideRouter,
  Routes,
  withComponentInputBinding,
} from '@angular/router';
import { importProvidersFrom } from '@angular/core';
import {
  MsalModule,
  MsalService,
  MsalGuard,
  MsalBroadcastService,
  MsalInterceptor,
  MsalRedirectComponent,
} from '@azure/msal-angular';
import {
  PublicClientApplication,
  BrowserCacheLocation,
  InteractionType,
} from '@azure/msal-browser';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { AuthInterceptorService } from './app/interceptors/auth-interceptor.service';
import { environment } from './environments/environment';

const msalInstance = new PublicClientApplication({
  auth: {
    clientId: environment.azure.clientId,
    authority: `${environment.azure.authority}${environment.azure.tenantId}`,
    redirectUri: environment.azure.redirectUri,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.SessionStorage
  },
});

const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./app/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'landing',
    loadComponent: () =>
      import('./app/landing/landing.component').then((m) => m.LandingComponent),
    canActivate: [MsalGuard],
  },
  { path: '**', redirectTo: 'login' },
];

async function initializeApp() {
  await msalInstance.initialize();

  bootstrapApplication(AppComponent, {
    providers: [
      provideRouter(routes, withComponentInputBinding()),
      provideHttpClient(withInterceptorsFromDi()),
      importProvidersFrom(
        MsalModule.forRoot(
          msalInstance,
          {
            interactionType: InteractionType.Redirect,
            authRequest: {
              scopes: environment.azure.scopes,
            },
          },
          {
            interactionType: InteractionType.Redirect,
            protectedResourceMap: new Map([
              [environment.azure.graph.apiUrl, environment.azure.graph.scopes],
              [environment.api.url, [environment.api.key]],
            ]),
          }
        )
      ),
      MsalService,
      MsalGuard,
      MsalBroadcastService,
      { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true },
      // {
      //   provide: HTTP_INTERCEPTORS,
      //   useClass: AuthInterceptorService,
      //   multi: true,
      // },
    ],
  }).catch((err) => console.error(err));
}

initializeApp();